import styled from 'styled-components/macro';

import {
  compose,
  space,
  color,
  typography,
  alignSelf,
  layout,

  // types
  SpaceProps,
  ColorProps,
  TypographyProps,
  AlignSelfProps,
  LayoutProps,
} from 'styled-system';
import textTransform, { TextTransformProps } from './textTransform';

type SpanProps = SpaceProps &
  ColorProps &
  TypographyProps &
  AlignSelfProps &
  LayoutProps &
  TextTransformProps;

const Span = styled.span<SpanProps>`
  ${compose(layout, space, color, typography, alignSelf, textTransform)}
`;

Span.defaultProps = {
  my: 0,
  fontWeight: 'normal',
};

export default Span;
